// AI-CONTEXT: See docs/features/updates-mailing.md
// Bepaalt of een bestemming die het inloggen heeft overleefd, veilig is om
// naartoe te sturen.

/**
 * Keurt de `next`-parameter van het inlogscherm.
 *
 * De parameter draagt de pagina waar iemand heen wilde voordat hij naar het
 * inlogscherm werd gestuurd — bijvoorbeeld de link uit een updatemail. Die
 * waarde komt uit de URL en is dus door de ontvanger te wijzigen; hij mag nooit
 * ongezien in `window.location.assign` belanden.
 *
 * Twee eisen, om twee verschillende redenen:
 *
 * 1. **Het moet een pad op deze site zijn.** Een absolute URL, een
 *    protocol-relatief pad (`//ergens-anders`) of een backslash maakt van onze
 *    eigen inlogpagina een springplank naar een willekeurige site — en de
 *    ontvanger klikte op een link in een mail van ons.
 * 2. **De organisatie in het pad moet van de gebruiker zijn.** Anders landt
 *    iemand in een omgeving waar hij niets mag zien; dat geeft geen foutmelding
 *    maar een leeg scherm, en dat leest als een storing.
 *
 * De poort valt dicht bij twijfel: is de lijst organisaties nog niet bekend,
 * dan is er geen bestemming.
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 *
 * @param {*} raw - De waarde van de `next`-parameter, al ontcijferd door URLSearchParams
 * @param {*} organisations - CompagnyID's waar de ingelogde gebruiker lid van is
 * @returns {string} Het pad om naartoe te gaan, of `''` als er geen veilige bestemming is
 */
const safeNextPath = (raw, organisations) => {

    if (typeof raw !== 'string' || raw === '') return ''
    if (!Array.isArray(organisations) || organisations.length === 0) return ''

    // Witruimte hoort niet in een pad, en een regelovergang is het klassieke
    // middel om er een tweede waarde achteraan te smokkelen. Een backslash
    // wordt door sommige browsers als schuine streep gelezen, dus `/\ergens`
    // gedraagt zich als `//ergens`.
    if (/[\s\\]/.test(raw)) return ''

    // Een gecodeerde schuine streep passeert de segmentcontrole hieronder en
    // wordt daarna alsnog een padscheiding.
    if (/%2f|%5c/i.test(raw)) return ''

    if (raw[0] !== '/') return ''
    if (raw[1] === '/') return ''

    const pathname = raw.split(/[?#]/)[0]
    const segments = pathname.split('/')

    // `/organisatie/../ergens-anders` komt door de organisatiecontrole heen en
    // wordt door de browser daarna tot iets heel anders opgelost.
    if (segments.some((segment) => segment === '..' || segment === '.')) return ''

    const tenant = segments[1]
    if (!tenant) return ''
    if (!organisations.includes(tenant)) return ''

    return raw

}

export default safeNextPath
